import React from 'react';

// Images
import logoIcon from '../../../img/icons/stm_logo_icon.svg';
import screenExample from '../../../img/screens/example_screen.png';
import FormLogin from '../../forms/form_page--login';


const LoginPage = () => {
    return (
        <div className="container container_width--full layout_signup">
            <div className="row">
                <div className="col-xs-12 col-md-6 bg_blue height_full" data-aos="fade-right">
                    <div className="inner-wrap flex-column">
                        <div className="flex-top">
                            <img src={logoIcon} alt="Search the Marketplace" />
                            <h3 className="text_white ft_w_600">Page Not Found</h3>
                            <p className="text_white">Don't worry, these things happen from time to time, in the mean time, make sure you are logged in and back to your dashboard</p>
                        </div>
                        <div className="flex-bottom" >
                            <img src={screenExample} alt="STM Example" data-aos="fade-up" className="height_100 width_100"/>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-6 bg_gradient_xlblue height_full">
                    <div className="inner-wrap" data-aos="fade-left">    
                        <FormLogin/>
                    </div>
                </div>
                
            </div>
        </div>
    );
}

export default LoginPage;